"use client";
import React from "react";
import { BgVideoContext } from "./shared/bgVideoContext";
const BackgroundVideoPlayPauseButtonPlaying = /*#__PURE__*/ React.forwardRef(function BackgroundVideoPlayPauseButtonPlaying({ children }, ref) {
    const { isPlaying } = React.useContext(BgVideoContext);
    return /*#__PURE__*/ React.createElement("span", {
        hidden: !isPlaying,
        ref: ref
    }, children);
});
export default BackgroundVideoPlayPauseButtonPlaying;
